/**
 * @fileoverview Web Vitals performance telemetry reporter.
 * Measures Core Web Vitals metrics (CLS, FID, FCP, LCP, TTFB) and reports to configured callback.
 */

/**
 * Initializes Core Web Vitals telemetry tracking and forwards metric events to a collector callback.
 *
 * @function reportWebVitals
 * @param {Function} [onPerfEntry] - Optional callback function to receive Metric performance entries.
 * @returns {void}
 */
const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
